module.exports = __webpack_public_path__ + "static/media/drop-slide-5.bb75a785.png";